@if (chartsData.length === 0) {
  <p class="no-data">No charts available</p>
}
<div class="dashboard-grid">
  @for (chartData of chartsData; track $index) {
    @defer (on viewport) {
      <app-chart-card
        [title]="chartData.title"
        [subtitle]="chartData.subtitle"
        [chartOptions]="chartData.chartOptions"
        [hasData]="chartData.hasData"
      ></app-chart-card>
    } @placeholder {
      <div class="chart-placeholder">Loading chart...</div>
    }
  }
</div>
